import { instance } from '../../requests/axios.instance';
import { uploadDirect } from '../../requests/directUpload';
import { getWebLinkSource } from '../utils/webLinkRegistry';

export function downloadFilesUrl(source = getWebLinkSource()) {
  if (!source?.id) throw new Error('Sauvegardez d’abord le modèle ou le site.');
  return source.type === 'web_template'
    ? `/proposals/web_templates/${source.id}/download_files`
    : `/proposal/${source.id}/download_files`;
}

export async function fetchDownloadFiles() {
  const response = await instance.get(downloadFilesUrl());
  return response.data;
}

export async function uploadDownloadFile(file, onProgress) {
  const url = downloadFilesUrl();
  const signedId = await uploadDirect(file, onProgress);
  const response = await instance.post(url, { filename: file.name, signed_id: signedId });
  return response.data;
}
